module.exports = __webpack_public_path__ + "static/img/logo.7f153491.png";